import React from "react";
import APP_CONSTANTS, {
  PLACEHOLDER_OPTION,
} from  '../../shared/constants/app_constants';

const NUMBER_VALUE_TYPES = [
  APP_CONSTANTS.VALUE_TYPES.INTEGER,
  APP_CONSTANTS.VALUE_TYPES.FLOAT,
  APP_CONSTANTS.VALUE_TYPES.CURRENCY
];

const FormAttributeSelectorWithMetadata = (props) => {
  let thisFormAttribute;
  // FIX this
  if (!!props && !!props.form_attributes && !!props.val1 ) {
    thisFormAttribute = props.form_attributes.find(fa => fa.uuid === props.val1);
  }
  let compoundValue = PLACEHOLDER_OPTION;
  if (props.val1 != undefined && props.val2 != undefined){
    compoundValue = `${props.val1}.${props.val2}`;
  }

  return (<select 
    className={`form-control condition-input condition-${props.inputName}-input`}
    name={`${props.inputName}`}
    value={compoundValue}
    onChange={props.onUpdateEvent}>
    <option value={PLACEHOLDER_OPTION}>Select an attribute</option>
    {
      props.selectableOptions.map((form_attribute, index) => {
        let thisFaValueType = form_attribute.abstract_value_type;
        let disableOption = (!!props.matchingValueType && thisFaValueType !== props.matchingValueType);
        if (!!props.matchingValueDataStructureType) {
          if (props.matchingValueDataStructureType != form_attribute.value_data_structure_type) {
            disableOption = true;
          }
        }
        if (!form_attribute.metadata_types || form_attribute.metadata_types.length === 0) { // this does not have metadata
          return (<option 
            value={`${form_attribute.uuid}.value`}
            disabled={disableOption}
            key={form_attribute.uuid}>
              {form_attribute.label} value
            </option>);
        } else {
          const faValue = `${form_attribute.uuid}.value`;
          return <optgroup label={form_attribute.label} key={form_attribute.id}>
            <option
              disabled={disableOption}
              value={faValue}>{form_attribute.name} value</option>
            { form_attribute.metadata_types.map((metadataType, index) => {
              const disableMdtOption = (!!props.matchingValueType && metadataType.abstract_value_type !== props.matchingValueType);
              const compoundValue = form_attribute.uuid + "." + metadataType.uuid;
              return <option 
                key={compoundValue}
                disabled={disableMdtOption}
                value={compoundValue}>
                  {form_attribute.name}.{metadataType.name}
                </option>;
            })}
          </optgroup>;
        }
      })
    }
  </select>);
}

export default FormAttributeSelectorWithMetadata;
